import styles from './CookieAcceptNotificationMobile.module.less'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import { useTypedLocalStorage } from '@/helpers/commonHooks/useTypedLocalStorage'
import { useTranslation } from 'react-i18next'
import AButton from '@/components/A/AButton/AButton'
import { Popup } from 'antd-mobile'

function CookieAcceptNotificationMobile() {
  const { t } = useTranslation()
  const [accept, setAccept] = useTypedLocalStorage('cookie-accepted', { defaultValue: false })
  const [visible, setVisible] = useState(!accept)

  useEffect(() => {
    setVisible(!accept)
  }, [accept])

  return (
    visible && (
      <Popup bodyClassName={styles.popup} visible={true} position='bottom' onMaskClick={() => {
        setVisible(false)
      }}>
        <div className={styles.cookieAcceptNotification} data-testid='cookie-notification'>
          <p className={styles.title}>{t('cookieAcceptNotification.title')}</p>
          <p className={styles.desc}>
            {t('cookieAcceptNotification.desc')}
            <Link to={PAGE_LINKS.privacy}>
              <span className={styles.highlight}>{t('cookieAcceptNotification.cookiePolicy')}</span>
            </Link>
          </p>
          <div className={styles.btnBox}>
            <AButton
              testId='cookie-notification-reject-btn'
              type='outlined'
              size='SM'
              className={styles.btn}
              onClick={() => {
                setVisible(false)
              }}
            >
              {t('cookieAcceptNotification.btn1')}
            </AButton>
            <AButton
              testId='cookie-notification-accept-btn'
              type='primary'
              size='SM'
              className={styles.btn}
              onClick={() => {
                setAccept(true)
              }}
            >
              {t('cookieAcceptNotification.btn2')}
            </AButton>
          </div>
        </div>
      </Popup>
    )
  )
}

export default CookieAcceptNotificationMobile
